import React, { useState } from 'react';
import { message } from 'antd';
import { Button } from '../../../design-system';
import { sendTestNotification } from './api';
import { CHANNEL_LABELS } from './constants';

function getDeliveryFailure(result, channel, channelLabel) {
    const deliveries = Array.isArray(result?.result?.deliveries)
        ? result.result.deliveries
        : [];
    const delivery = deliveries.find((item) => item.channel === channel);

    if (!delivery) {
        return `No ${channelLabel} delivery was attempted. Check the saved notification preferences for this channel.`;
    }

    if (delivery.status !== 'sent') {
        const reason = delivery.reason ? ` (${delivery.reason})` : '';
        return `Test ${channelLabel} was ${delivery.status || 'not sent'}${reason}.`;
    }

    return null;
}

const TestNotificationButton = ({ channel, disabled = false, onSent }) => {
    const [loading, setLoading] = useState(false);
    const channelLabel = CHANNEL_LABELS[channel] || channel;

    const handleClick = async () => {
        setLoading(true);
        try {
            const result = await sendTestNotification(channel);
            const deliveryFailure = getDeliveryFailure(result, channel, channelLabel);
            if (deliveryFailure) {
                throw new Error(deliveryFailure);
            }

            message.success(`Test sent — check your ${channelLabel} in a moment.`);
            if (onSent) {
                onSent(channel);
            }
        } catch (err) {
            const msg =
                err?.response?.data?.message ||
                err?.response?.data?.data?.message ||
                err?.message ||
                'Failed to send test notification';
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            variant="secondary"
            size="small"
            uppercase={false}
            onClick={handleClick}
            disabled={disabled || loading}
            loading={loading}
        >
            Send test {channelLabel}
        </Button>
    );
};

export default TestNotificationButton;
